import * as React from "react";
import DataSource, { DATE_DISPLAY_FORMAT } from "../lib/DataSource";
import {
  Alert,
  Breadcrumb,
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space,
  Table,
} from "antd";
import Moment from "moment";
import { FetchWithAuth } from "digimaker-ui/util";
import { Link } from "react-router-dom";
import FormItem from "antd/lib/form/FormItem";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { DeleteFilled, EditFilled, FileAddFilled } from "@ant-design/icons";

export default class SubjectView extends React.Component<
  { id: string },
  { data: any; action: string; actData: any; checked: boolean }
> {
  private formRef = React.createRef<FormInstance>();

  constructor(props: any) {
    super(props);
    this.state = { data: "", action: "", actData: {}, checked: false };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    FetchWithAuth("icd/subject/get/" + this.props.id)
      .then((data) => {
        this.setState({ data: data.data });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  submit(values: any) {
    let params = [
      {
        name: values["name"],
        percentage: parseFloat(values["percentage"]),
        is_exemption: this.state.checked,
      },
    ];
    FetchWithAuth("icd/subject/assessment/add-update/" + this.props.id, {
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((data) => {
        this.setState({ action: "" });
        message.success({ content: "Assessment is added!" });
        this.fetchData();
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  exemptionChange(checked: boolean) {
    if (checked) {
      this.formRef.current!.setFieldsValue({ name: "EXE", percentage: 100 });
    }
    this.setState({ checked: checked });
  }

  async update(id: number, values: any) {
    const params = [
      {
        name: values["name"],
        percentage: parseFloat(values["percentage"]),
        is_exemption: this.state.checked,
        id: id,
      },
    ];
    const res = await FetchWithAuth(
      "icd/subject/assessment/add-update/" + this.props.id,
      { method: "POST", body: JSON.stringify(params) },
    );
    if (res.error == false) {
      this.setState({ action: "", actData: {} });
      message.success({ content: "Assessment is updated!" });
      this.fetchData();
    }
  }

  delete(id: number, name: any) {
    Modal.confirm({
      title: "Confirm to delete",
      content: (
        <div>
          <p>
            Are you sure to delete <b>{name}</b>?{" "}
          </p>
          <Alert
            type="warning"
            message="Note: make sure there is no record on this assessment!"
          />
        </div>
      ),
      onOk: async () => {
        const res = await FetchWithAuth("icd/subject/assessment/delete/" + id, {
          method: "POST",
        });
        if (res.error == false) {
          message.success({ content: "Assessment is deleted!" });
          this.fetchData();
        }
      },
    });
  }

  render() {
    let data = this.state.data;
    if (!data) {
      return "";
    }
    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/subject/list">Subjects</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>View subject</Breadcrumb.Item>
        </Breadcrumb>
        <div className="main-top">
          <h2>Subject: {data.name}</h2>
        </div>
        <Row>
          <Col span={6}>
            <label>Code: </label>
          </Col>
          <Col>
            <div>{data.code}</div>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <label>Credit: </label>
          </Col>
          <Col>
            <div>{data.credit}</div>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <label>Stage year: </label>
          </Col>
          <Col>
            <div>{data.stage_year}</div>
          </Col>
        </Row>
        <div className="right">
          <Button type="link" onClick={() => this.setState({ action: "add" })}>
            <FileAddFilled />
            Add assessment
          </Button>
        </div>

        {this.state.action == "add" && (
          <Modal
            visible={true}
            title="Assessment"
            onCancel={() => this.setState({ action: "" })}
            footer={false}
          >
            <Form
              ref={this.formRef}
              onFinish={(values: any) => this.submit(values)}
            >
              <FormItem
                name="name"
                labelCol={{ span: 6 }}
                rules={[{ required: true, message: "Please input!" }]}
                label="Name"
              >
                <Input />
              </FormItem>
              <FormItem
                name="percentage"
                labelCol={{ span: 6 }}
                rules={[{ required: true, message: "Please input!" }]}
                label="Percentage"
              >
                <InputNumber max={100} min={0} />
                {/* <Input type="number" max={100} min={0} /> */}
              </FormItem>
              <Checkbox
                value="1"
                onChange={(e) => this.exemptionChange(e.target.checked)}
                name="is_exemption"
              >
                Is exemption
              </Checkbox>
              <div className="text-right">
                <Space>
                  <Button onClick={() => this.setState({ action: "" })}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Space>
              </div>
            </Form>
          </Modal>
        )}

        {this.state.action == "edit" && (
          <Modal
            visible={true}
            title="Assessment"
            onCancel={() => this.setState({ action: "" })}
            footer={false}
          >
            <Form
              ref={this.formRef}
              onFinish={(values: any) =>
                this.update(this.state.actData.id, values)
              }
            >
              <FormItem
                name="name"
                initialValue={this.state.actData.assessment}
                labelCol={{ span: 6 }}
                rules={[{ required: true, message: "Please input!" }]}
                label="Name"
              >
                <Input />
              </FormItem>
              <FormItem
                name="percentage"
                initialValue={this.state.actData.percentage}
                labelCol={{ span: 6 }}
                rules={[{ required: true, message: "Please input!" }]}
                label="Percentage"
              >
                <InputNumber max={100} min={0} />
                {/* <Input type="number" max={100} min={0} /> */}
              </FormItem>
              <Checkbox
                value="1"
                defaultChecked={this.state.actData.is_exemption}
                onChange={(e) => this.exemptionChange(e.target.checked)}
                name="is_exemption"
              >
                Is exemption
              </Checkbox>
              <div className="text-right">
                <Space>
                  <Button onClick={() => this.setState({ action: "" })}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Space>
              </div>
            </Form>
          </Modal>
        )}

        <h3>Assessments</h3>
        <div>
          {!data.assessments && <Alert message="No assessement found" />}
          {data.assessments && (
            <table className="table">
              <tbody>
                <tr>
                  <td>ID</td>
                  <td>Assessment</td>
                  <td>Percentage</td>
                  <td>Exemption</td>
                  <td></td>
                </tr>
                {data.assessments.map((assessment: any) => (
                  <tr>
                    <td>{assessment.id}</td>
                    <td>{assessment.assessment}</td>
                    <td>{assessment.percentage}</td>
                    <td>{assessment.is_exemption ? "Yes" : ""}</td>
                    <td>
                      <Button
                        type="link"
                        onClick={() =>
                          this.setState({ action: "edit", actData: assessment })
                        }
                      >
                        <EditFilled />
                        Edit
                      </Button>
                      <Button
                        type="link"
                        onClick={() =>
                          this.delete(assessment.id, assessment.assessment)
                        }
                      >
                        <DeleteFilled />
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}
